<template>
  <div class="about-page">
    <div class="content-scroll">
      <div class="content-card">
        <p>朋友，你好！这里是<span class="highlight">幻之大地</span>（<a href="http://www.huanzhidadi.com">www.huanzhidadi.com</a>）</p>
        <p>"幻之大地"是一个多人在线的虚拟人生社区。在这个建立在网络上的"世界"中，您将和其它的用户一样扮演一个虚拟的角色，并通过各种行为培养其成为您所希望的虚拟人格。在"幻之大地"的设计过程中，参考了多种类型的电子游戏系统，因此可以说这个社区和游戏有着千丝万缕的联系。因为从本质上说，整个"幻之大地"本身就是一个以生活类MUD为蓝本的虚拟世界。</p>
        <p>还记得我们平时在生活中的琐碎与不快么？在这里没有，只有娱乐。你可以尽情的去做各种事情，把你的角色培养成你梦想中呼风唤雨的形象、或者仅仅是安逸的生活，只要你喜欢。即使你失败了，大不了重新登录一个用户从头再来而已……尽管所有的这一切，都只是网络上虚幻的梦而已，但是让单调的人生多一点充满色彩的梦，本身已经是一件让人激动的事情。</p>
        <p>有一部非常出名的电影相信大家都看过，对，就是《黑客帝国》。我们希望有一天，我们可以营造一个虚拟的世界，让大家在里面重新活一次、两次、三次……直到永远。我们知道我们离这个目标还有无限远的距离，刚刚诞生的"幻之大地"也无法称得上完善。但我们相信自己做出的努力，我们也还会一直努力下去，努力向那个目标迈进，不论是一小步还是一大步。希望你们会喜欢"幻之大地"，也希望有一天，你们会加入到我们当中来，一起建设一个网络上的美丽国度，因为，我们需要你们。</p>
        <p class="thanks">谢谢你们！</p>
        <p class="signature">WWW.HUANZHIDADI.COM全体工作人员</p>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'login'}">← 返回登录</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    methods: {
    },
    mounted: function () {
      var _this = this;
    },
    data(){
      return {
      }
    }
  }
  
</script>
<style scoped>
.about-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 30px;
  box-sizing: border-box;
}

.content-card p {
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.9;
  color: #4a4a4a;
  text-indent: 2em;
}

.content-card p:first-child {
  text-indent: 0;
}

.content-card p:last-of-type {
  text-indent: 0;
}

.content-card .highlight {
  color: #e6422e;
  font-weight: 600;
}

.content-card .thanks {
  text-align: center;
  color: #e6422e;
  font-weight: 600;
  text-indent: 0;
  margin-bottom: 4px;
}

.content-card .signature {
  text-align: right;
  color: #606266;
  text-indent: 0;
  margin-bottom: 0;
}

.content-card a {
  color: #409eff;
  text-decoration: none;
}

.content-card a:hover {
  text-decoration: underline;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 20px 16px;
    border-radius: 10px;
  }

  .content-card p {
    font-size: 14px;
    line-height: 1.75;
    margin-bottom: 12px;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
